import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "preloader" }

import loaderJSON from '@/static/img/preloader-web-blue.json'
import { Vue3Lottie } from 'vue3-lottie'

const __default__ = {
    name: 'vita-loader'
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Vue3Lottie), {
      class: "animate",
      animationData: _unref(loaderJSON),
      width: "140px",
      height: "140px"
    }, null, 8, ["animationData"])
  ]))
}
}

})